import { useEffect, useRef, useState } from "react";

/**
 * Returns true for `ms` after `value` changes (skipping the initial mount) —
 * a one-shot "it registered" flash. Used by the smart-view chip so a ⌃⌥F toggle
 * fired while the editor has focus still gives a visible confirmation in the
 * board chrome, not just the (peripheral) steady-state colour flip.
 */
export function useFlashOnChange(value: unknown, ms = 450): boolean {
  const [flash, setFlash] = useState(false);
  const mounted = useRef(false);
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      return;
    }
    setFlash(true);
    const t = setTimeout(() => setFlash(false), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return flash;
}
